import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { ButtonPrimary, ButtonSecondary } from '../../_ui/button'
import RatingGroup from './rating-group'
import ProductRatingCard from './product-rating-card'
import { useReviewOrderStore } from '../store/review-order-store'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  max-width: 20rem;
  max-height: 35rem;
  margin: 0 auto;
`

const IntroText = styled.p`
  line-height: 1;
  margin: 0;
  padding: 0.5rem 0;
  font-size: 12px;
  color: #333;
  white-space: pre-line;
  background: #f9f9f9;
  border-left: 4px solid #4caf50;
  padding-left: 12px;
  border-radius: 6px;
`

const TextareaStyled = styled.textarea`
  width: 100%;
  padding: 12px;
  min-height: 110px;
  border: 1px solid #ddd;
  border-radius: 8px;
  resize: vertical;
  font-size: 14px;
`

const ActionWrapper = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.75rem 0;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(6px);
  display: flex;
  gap: 10px;
  z-index: 20;
`

const ProductsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const getIntroText = status => {
  switch (status) {
    case 'success':
      return 'Pesananmu sudah berhasil dikirim 🎉\nBantu seller berkembang dengan membagikan pengalamanmu saat belanja.'
    case 'refund':
      return 'Pesananmu dikembalikan 💔\nCeritakan pengalamanmu agar kami bisa meningkatkan layanan.'
    case 'success_with_cod_refund':
      return 'Pesananmu selesai dengan COD dan ada pengembalian 💡\nBagikan pengalamanmu agar seller dan kami lebih baik.'
    default:
      return 'Pesananmu selesai 🎉\nBantu kami meningkatkan kualitas layanan dengan membagikan pengalamanmu.'
  }
}

export default function AddReviewOrderForm() {
  const token = useSelector(state => state.token)

  const {
    order,
    chatQuality,
    shippingSpeed,
    reviewText,
    productRatings,
    setChatQuality,
    setShippingSpeed,
    setReviewText,
    updateProductRating,
    isValid,
    submit,
    closeReview,
  } = useReviewOrderStore(state => ({
    order: state.order,
    chatQuality: state.chatQuality,
    shippingSpeed: state.shippingSpeed,
    reviewText: state.reviewText,
    productRatings: state.productRatings,
    setChatQuality: state.setChatQuality,
    setShippingSpeed: state.setShippingSpeed,
    setReviewText: state.setReviewText,
    updateProductRating: state.updateProductRating,
    isValid: state.isValid(),
    submit: state.submit,
    closeReview: state.closeReview,
  }))

  if (!order) return null

  return (
    <Wrapper>
      <IntroText>{getIntroText(order.status)}</IntroText>

      {/* <OrderSummary order={order} /> */}

      <RatingGroup
        label='Kualitas Chat Seller'
        value={chatQuality}
        onChange={setChatQuality}
      />

      <RatingGroup
        label='Kecepatan Proses Pesanan'
        value={shippingSpeed}
        onChange={setShippingSpeed}
      />

      <TextareaStyled
        placeholder='Ceritakan pengalamanmu (opsional)...'
        value={reviewText}
        onChange={e => setReviewText(e.target.value)}
      />

      <ProductsWrapper>
        {order.product.map((p, index) => {
          const rating = productRatings[index]

          return (
            <ProductRatingCard
              key={p.orderItemId}
              name={p.name}
              image={p.picture}
              accuracy={rating.accuracy}
              quality={rating.quality}
              review={rating.review}
              onAccuracyChange={val =>
                updateProductRating(index, 'accuracy', val)
              }
              onQualityChange={val =>
                updateProductRating(index, 'quality', val)
              }
              onReviewChange={val => updateProductRating(index, 'review', val)}
            />
          )
        })}
      </ProductsWrapper>

      <ActionWrapper>
        <ButtonSecondary fullWidth size='small' onClick={closeReview}>
          Nanti Dulu
        </ButtonSecondary>

        <ButtonPrimary
          fullWidth
          size='small'
          disabled={!isValid}
          onClick={() => submit(token)}
        >
          Kirim Ulasan
        </ButtonPrimary>
      </ActionWrapper>
    </Wrapper>
  )
}
